import { ExtraSmall } from "@/src/components/typography";

import type { ReactNode } from "react";

/** Bordered, divided panel that holds a stack of `SummaryRow`s (shared by the review + success steps). */
export function SummaryPanel({ children }: { children: ReactNode }) {
  return <div className="w-full divide-y rounded-lg border bg-background px-4 text-left">{children}</div>;
}

/** One detail row: an accent icon chip, an optional eyebrow label, and its value content. */
export function SummaryRow({ icon, label, children }: { icon: ReactNode; label?: string; children: ReactNode }) {
  return (
    <div className="flex items-start gap-2 py-4">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent text-foreground">
        {icon}
      </span>
      <div className="min-w-0">
        {label && <ExtraSmall className="block uppercase tracking-[0.12em] text-muted-foreground">{label}</ExtraSmall>}
        <div className="text-sm text-foreground">{children}</div>
      </div>
    </div>
  );
}
